import React from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';
import {
  TouchableOpacity,
  View,
  KeyboardAvoidingView,
  Platform,
} from 'react-native';

import JoinHunt from 'src/JoinRedeem/JoinHunt';
import {ContinueButton} from 'src/Modules/CommonView';
import {addVoucherShows} from '../Redux/reducers/ticket_vouchers.reducer';
import {useDispatch} from 'react-redux';
import {navigationRef} from 'src/Nav/navigationHelpers';
import useParams from 'src/Hooks/useParams';
import {ScrollView} from 'react-native-gesture-handler';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

const JoinHuntModal = ({route}) => {
  const {width} = useWindowDimensionsSafe();
  console.log('JoinHuntModal nav params', {route});

  const {autoFound = false} = useParams();
  const dispatch = useDispatch();

  return (
    <SafeAreaView style={{flex: 1}}>
      <TouchableOpacity
        style={{flex: 1}}
        onPress={() => navigationRef.goBack(null)}
      />
      <KeyboardAvoidingView
        style={{flex: 1, justifyContent: 'flex-end'}}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        enabled>
        <View>
          <ScrollView style={{minHeight: 600}}>
            <View
              style={{
                width,
                backgroundColor: global?.color?.white,
                minHeight: 460,
                borderRadius: 10,
              }}>
              <JoinHunt
                containerStyle={{flex: 0}}
                route={route}
                isModal
                hideVoucherSearch={true}
              />
              <View
                style={{alignItems: 'center', marginTop: 10, marginBottom: 60}}>
                <ContinueButton
                  text={'Cancel - Redeem Later'}
                  width={220}
                  background={global?.color?.gray3}
                  handlePress={() => {
                    if (autoFound) {
                      dispatch(addVoucherShows(1));
                    }
                    navigationRef.goBack(null);
                  }}
                />
              </View>
            </View>
          </ScrollView>
        </View>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

//eslint-disable-next-line
export default JoinHuntModal;
